module.exports = { id: "price", url: "/build/app/img/symbols.svg#price", viewBox: "", toString: function() { return this.url; } };